/**
 * Document HTML pour iframe de salle d’attente webinaire (aperçu institution ou salle réelle).
 * Les couleurs suivent les variables `--inst-player-*` du conteneur thème.
 */
export function buildWebinarWaitingRoomSrcDoc(bodyHtml: string, root: HTMLElement | null): string {
  const el = root ?? document.documentElement;
  const cs = getComputedStyle(el);
  const fg = cs.getPropertyValue('--inst-player-text').trim() || '#111827';
  const primary = cs.getPropertyValue('--inst-player-primary').trim() || '#0C1C38';
  const muted = cs.getPropertyValue('--inst-player-text-muted').trim() || '#6b7280';
  return `<!DOCTYPE html><html><head><meta charset="utf-8"/><style>
    html,body{margin:0;padding:0;background:transparent;overflow:hidden;}
    body{display:flex;flex-direction:column;align-items:center;justify-content:center;box-sizing:border-box;padding:12px 20px;font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:${fg};line-height:1.65;font-size:1.0625rem;text-align:center;}
    body *{max-width:36rem;}
    a{color:${primary};text-decoration:none;} a:hover{text-decoration:underline;}
    h1,h2,h3,h4{margin:0.4em 0;color:${fg};font-weight:600;line-height:1.25;}
    p{margin:0.45em 0;}
    small{color:${muted};font-size:0.875em;}
    ul,ol{margin:0.5em 0;padding-left:1.25em;text-align:left;align-self:center;max-width:min(100%,28rem);}
  </style></head><body>${bodyHtml}</body></html>`;
}
